import { createFileRoute } from "@tanstack/react-router";
import AdminMediaPage from "@/admin/pages/media";

export const Route = createFileRoute("/admin/media/")({
  component: AdminMediaPage,
});
